export default __webpack_public_path__ + "static/media/camera_tampering_placeholder_thumbnail.e846dacf.png";